import DeleteConfirmation from "components/modal/delete-confirmation"
import DowntimeBasic from "components/market-lease/controls/downtime-basic"
import DowntimeNamedItem from "components/market-lease/controls/downtime-named-item"
import FreeRentBasic from "components/market-lease/controls/free-rent-basic"
import FreeRentNamedItem from "components/market-lease/controls/free-rent-named-item"
import LCBasic from "components/market-lease/controls/lc-basic"
import LCNamedItem from "components/market-lease/controls/lc-named-item"
import OCBasic from "components/market-lease/controls/oc-basic"
import OCNamedItem from "components/market-lease/controls/oc-named-item"
import OverageBasic from "components/market-lease/controls/overage-basic"
import OverageInherit from "components/market-lease/controls/overage-inherit"
import RecoveriesAmt from "components/market-lease/controls/recoveries-amt"
import RecoveriesDetailedAmt from "components/market-lease/controls/recoveries-detailed-amt"
import RecoveriesNamed from "components/market-lease/controls/recoveries-named"
import RecoveriesProRata from "components/market-lease/controls/recoveries-pro-rata"
import RecoveriesTenantMgmtFee from "components/market-lease/controls/recoveries-tenant-mgmt-fee"
import RecoveryGroups from "components/market-lease/controls/recovery-groups"
import RenewalProbBasic from "components/market-lease/controls/renewal-prob-basic"
import RenewalProbNamedItem from "components/market-lease/controls/renewal-prob-named-item"
import RenewalProbHover from "components/market-lease/controls/renewal-prob-hover"
import RentBasic from "components/market-lease/controls/rent-basic"
import RentNamedItem from "components/market-lease/controls/rent-named-item"
import RentAdvanced from "components/market-lease/controls/rent-advanced"
import SalesBasic from "components/market-lease/controls/sales-basic"
import SalesInherit  from "components/market-lease/controls/sales-inherit"
import TiBasic from "components/market-lease/controls/ti-basic"
import TiNamedItem from "components/market-lease/controls/ti-named-item"

export default {
  DeleteConfirmation,
  DowntimeBasic,
  DowntimeNamedItem,
  FreeRentBasic,
  FreeRentNamedItem,
  LCBasic,
  LCNamedItem,
  OCBasic,
  OCNamedItem,
  OverageBasic,
  OverageInherit,
  RecoveriesAmt,
  RecoveriesDetailedAmt,
  RecoveriesNamed,
  RecoveryGroups,
  RecoveriesProRata,
  RecoveriesTenantMgmtFee,
  RenewalProbBasic,
  RenewalProbNamedItem,
  RenewalProbHover,
  RentBasic,
  RentNamedItem,
  RentAdvanced,
  SalesBasic,
  SalesInherit,
  TiBasic,
  TiNamedItem,
}
